<template>
    <div>
        <app-page-error v-if="showErrorPage" />

        <div v-else id="projectContainer" :style="projectBackgroundStyle">
            
            <project-view-content/>
        </div>

       
    </div>
</template>

     
<script>
import AppPageError from '@/components/AppPageError';
import store from '@/store/index';
import _ from 'underscore';
import ProjectViewContent from '@/components/ProjectViewContent';
import { projectBackground } from '@/lib/helpers';




import { fetchItem } from '@/services/API';

export default {
    name: 'ProjectView',
    components: {
        AppPageError,
        ProjectViewContent
    },

    props: {
        projectId: { type: String, default: undefined },
    },

    data() {
        return {
            selectedItem: {},
            items: this.$store.getters.projectContent || [],
            showErrorPage: false,
        };
    },
    computed: {
        isLoggedIn() {
            return this.$store.getters.isLoggedIn;
        },
        project() {
            // console.log('project', this.$store.getters.project);
            return this.$store.getters.project;
        },
        isMap(){
            return this.project.format=="PROJECT_TYPE_MAP";
        },
        isWall(){
            return this.project.format=="PROJECT_TYPE_WALL";
        },
        projectBackgroundStyle() {
            if(this.isMap){
                return "background: transparent;";
            }
            let bg = projectBackground(
                !_.isEmpty(this.project.image)
                    ? this.project.image
                    : {
                        url:
                            process.env.VUE_APP_ROOT_URL +
                            '/img/project_background_default_grey.jpg',
                    }
            );
            return bg;
            
            
        },
    },
    
    mounted: function () {
        store
        .dispatch('fetchProjectSimplified', this.$route.params.projectId)
        .catch((e) => {
            console.error('failed to fetch project', e.status || e);
            this.showErrorPage = true;
        }).then(() => {
            const inIframe = window.self !== window.top;
            let canViewInIframe = false;
            if (this.project.owner.school && this.project.owner.school.configuration) {
                canViewInIframe = this.project.owner.school.configuration.project.showEmbed;
                // console.log('school',this.project.owner.school.configuration.project.showEmbed)
            } else {
                canViewInIframe = this.project.owner.plan.configuration.project.showEmbed;
                // console.log('user', this.project.owner.plan.configuration.project.showEmbed);
            }
            if (inIframe && !canViewInIframe) { 
                // console.log("can view in iframe")
                this.showErrorPage = true;

            }
                //console.log("iframe?", inIframe,this.project.owner)
                // console.log("is map?",this.isMap)
                // console.log("is wall?",this.isWall)
            });
        
        /*if (!this.isLoggedIn && (this.project.privacy == 'secret' || this.project.privacy == 'public') && this.project.allowAnonymous) {
            this.$store
            .dispatch('anonymousLogin', 'anonymous')
            .then(() => {
                // console.log(this.$store.getters.user);
            });
        }*/ // desactivat el login anònim
        

       
    },
    beforeDestroy() {},
    destroyed() {
        this.$store.dispatch('cleanProject');
        if (
            this.$store.getters.isAnonymous &&
            (this.project.privacy == 'secret' ||
                this.project.privacy == 'public') &&
            this.project.allowAnonymous
        ) {
            this.$store.dispatch('logout');
        }
    },

    methods: {
        
    },
};
</script>

<style scoped lang="css">



</style>
